<template>
  <div class="container1">
    <page-header></page-header>
    <payment-result isPayFail></payment-result>
    <!-- PaymentFailure -->
    <footer-page></footer-page>
  </div>
</template>

<script>
import PageHeader from '@/components/PageHeader.vue'
import PaymentResult from './components/PaymentResult.vue'
import FooterPage from '@/components/FooterPage.vue'
export default {
  name: 'PaymentFailure',
  components: {
    PageHeader,
    PaymentResult,
    FooterPage,
  }
}
</script>

<style lang="scss" scoped></style>
